export default __webpack_public_path__ + "static/media/Detect-Threat-Intelligence.3a1dbfe6.svg";